// Angular
import { Component, Input } from '@angular/core';

// Afidium
import { ISectorAir, IGetBookingsAirResponse, ITraveller } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { Yii } from 'libraries/interfaces/Yii';
import { ILabels } from 'libraries/interfaces/ILabels';
import { IGetEnumsService } from 'libraries/service/booking/enums/IGetEnums';

@Component({
    selector: 'sector-air-details',
    template: `
        <sector-air-flight-details *ngIf="sectorData"
                                   [sectorData]="sectorData">
        </sector-air-flight-details>

        <ng-container *ngIf="bookingData?.traveller?.length; else noTravellerDefined">
            <sector-air-details-traveller *ngFor="let traveller of bookingData.traveller; trackBy: trackByFn; let odd = odd"
                                          [class.odd]="odd"
                                          [travellerData]="traveller"
                                          [sectorXId]="sectorData.xId"
                                          [bookingData]="bookingData"
                                          [serviceEnum]="serviceEnum">
            </sector-air-details-traveller>
        </ng-container>

        <ng-template #noTravellerDefined>
            <notification>{{ labels.noTravellerDefined }}</notification>
        </ng-template>
    `,
    styles: [`
        sector-air-details-traveller {
            padding: .75rem;
            padding-top: 0;
            display: block;
            background-color: #f2f2f2;
        }

        sector-air-details-traveller.odd {
            background-color: #f9fafc;
        }
    `]
})

export class SectorAirDetailsComponent {
    @Input()
    public sectorData: ISectorAir;

    @Input()
    public bookingData: IGetBookingsAirResponse;

    @Input()
    public serviceEnum: IGetEnumsService[];

    public labels: ILabels = {
        noTravellerDefined: Yii.t('wui-shared-js', "Aucun voyageur pour cette étape")
    };

    public trackByFn(index: number, traveller: ITraveller): string {
        return traveller.xId;
    }
}
